<template>
  <footer id="main-footer">
    <ContentPadding>
      <ContentWrapper>
        <div id="footer-header">
          <ul id="links">
            <li>
              <a href="http://www.bistudio.com/cookie-policy" target="_blank"
                >COOKIES</a
              >
            </li>
            <li class="sep">|</li>
            <li>
              <a href="https://www.bistudio.com/privacy-policy" target="_blank"
                >PRIVACY POLICY</a
              >
            </li>
            <li class="sep">|</li>
            <li>
              <a href="https://ylands.com/eula" target="_blank">EULA</a>
              &
              <a href="https://ylands.com/terms" target="_blank">TERMS</a>
            </li>
          </ul>
          <div id="globe" class="hide-980">
            <img
              src="../assets/img/globe.png"
              alt="Ylands Globe"
              loading="lazy"
            />
          </div>
          <ul id="social">
            <li>
              <a
                href="https://www.youtube.com/channel/UC3NF7klLgt4sylAROJfSCtw"
                target="_blank"
              >
                <YoutubeIcon />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/bohemiainteract" target="_blank">
                <TwitterIcon />
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/BohemiaInteractive/">
                <FacebookIcon />
              </a>
            </li>
            <li class="hide-1280" id="text-follow-social">
              <p>FOLLOW BOHEMIA INTERACTIVE ON</p>
            </li>
          </ul>
        </div>
        <ul id="footer-logos">
          <li>
            <a
              href="https://bistudio.com"
              target="_blank"
              title="Bohemia Interactive"
            >
              <BohemiaLogo
                alt="Bohemia Interactive logo"
                loading="lazy"
                width="100%"
                height="60px"
              />
            </a>
          </li>
          <li>
            <a
              href="https://incubator.bistudio.com"
              target="_blank"
              title="Bohemia Incubator"
            >
              <img
                src="https://static.bistudio.com/images/ylands/web/footer/Incubator-Logo.svg"
                alt="Bohemia Incubator logo"
                loading="lazy"
                width="198px"
                height="76px"
              />
            </a>
          </li>
          <li>
            <a href="https://unity3d.com/" target="_blank" title="Unity 3D">
              <UnityLogo
                alt="Unity 3d - game engine logo"
                loading="lazy"
                width="140px"
                height="51px"
              />
            </a>
          </li>
          <li>
            <a
              href="https://developer.nvidia.com/gameworks"
              title="nVidia GameWorks"
              target="_blank"
            >
              <NvidiaLogo
                alt="nVidia GameWorks logo"
                loading="lazy"
                width="140px"
                height="32px"
              />
            </a>
          </li>
          <li>
            <a href="http://www.pegi.info/" target="_blank" title="Pegi 12">
              <PegiLogo
                id="pegi-rating"
                alt="Pegi 12 logo"
                loading="lazy"
                width="64px"
                height="77px"
              />
            </a>
          </li>
        </ul>
        <div class="divider"></div>
        <p id="footer-copyright">
          © 2017 - {{ currentYear() }} YLANDS® and BOHEMIA INTERACTIVE® are
          registered trademarks of BOHEMIA INTERACTIVE a.s. All rights reserved.
        </p>
      </ContentWrapper>
    </ContentPadding>
  </footer>
</template>

<script>
import ContentWrapper from "./partial/ContentWrapper";
import ContentPadding from "./partial/ContentPadding";

import TwitterIcon from "../assets/svg/twitter.svg?inline";
import FacebookIcon from "../assets/svg/facebook.svg?inline";
import YoutubeIcon from "../assets/svg/youtube.svg?inline";
import BohemiaLogo from "../assets/svg/bohemia_logo_white.svg?inline";
import PegiLogo from "./../assets/svg/rating_pegi_12.svg?inline";
import NvidiaLogo from "../assets/svg/nvidia_gameworks.svg?inline";
import UnityLogo from "../assets/svg/unity_logo.svg?inline";

export default {
  name: "main-footer",
  components: {
    ContentWrapper,
    ContentPadding,
    TwitterIcon,
    FacebookIcon,
    YoutubeIcon,
    BohemiaLogo,
    PegiLogo,
    NvidiaLogo,
    UnityLogo
  },
  methods: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped lang="scss">
#main-footer {
  font-family: "Istok Web", sans-serif;
  font-size: 14px;
  background-color: #0a294a;
  position: relative;
  z-index: 10;
  color: #fff;

  @media (max-width: 980px) {
    font-size: 0.8em;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
  }

  #footer-header {
    list-style: none;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    position: relative;
    top: -70px;
    margin-bottom: -50px;

    @media (max-width: 980px) {
      top: 0;
      padding-top: 2em;
      display: block;
      margin-bottom: 0;
    }

    #links {
      li {
        margin-right: 1em;

        a {
          font-size: 0.85714em;
          color: #fff;
          text-decoration: none;
          &:hover {
            color: rgb(255, 163, 6);
          }
        }
      }
      .sep {
        color: #ffa306;
      }

      @media (max-width: 980px) {
        margin-bottom: 2em;
      }
    }

    #globe {
      text-align: center;
    }
    #social {
      flex-direction: row-reverse;
      align-items: center;

      #text-follow-social {
        text-align: right;
        padding-right: 1em;
      }

      li {
        margin-left: 1em;
        a {
          display: inline-block;
          svg {
            padding: 0;
            vertical-align: middle;
            width: 37px;
            height: 37px;
            fill: #fff;

            &:hover {
              fill: #ffa306;
            }

            @media (max-width: 980px) {
              width: 28px;
              height: 28px;
            }
          }
        }

        @media (max-width: 980px) {
          &:nth-child(3) {
            margin-left: 0;
          }
        }
      }
    }
  }

  #links,
  #social {
    flex: 1 1 100%;
  }

  #footer-logos {
    padding: 0;
    margin: 2em 0;
    list-style-type: none;
    width: 100%;
    height: auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    li {
      padding: 0 1em 4em 1em;
      a {
        display: inline-block;
        svg {
          fill: #fff;
        }
      }
    }

    @media (max-width: 597px) {
      flex-direction: column;
      justify-content: center;

      li {
        padding-top: 1em;
        padding-bottom: 1em;
      }
    }

    @media (min-width: 598px) and (max-width: 980px) {
      margin-top: 2em;
      padding-top: 1em;

      li {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
      }
    }
  }

  .divider {
    height: 1px;
    width: 100%;
    background-color: #75838f;
  }

  #footer-copyright {
    margin: 0;
    padding: 4em 0;
    text-align: center;
    font-size: 0.875em;
  }
}
</style>
